import React from 'react';
import './ThemeToggle.css';
import useLongPressTooltip from './useLongPressTooltip';

const ThemeToggle = ({ theme, onToggle }) => {
  const isDark = theme === 'dark';
  const label = `Switch to ${isDark ? 'light' : 'dark'} mode`;
  const { isVisible, buttonProps } = useLongPressTooltip(onToggle);

  return (
    <div className="theme-toggle-wrap">
      <button
        type="button"
        className="theme-toggle"
        {...buttonProps}
        aria-label={label}
        aria-describedby="theme-toggle-tooltip"
      >
        {isDark ? (
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M20.3 15.3A8.5 8.5 0 0 1 8.7 3.7 8.5 8.5 0 1 0 20.3 15.3Z" />
          </svg>
        )}
      </button>
      <span
        id="theme-toggle-tooltip"
        className={`theme-toggle__tooltip${isVisible ? ' is-touch-visible' : ''}`}
        role="tooltip"
      >
        {label}
      </span>
    </div>
  );
};

export default ThemeToggle;
